<div #top class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div
                        [ngClass]="!isMobileXL() ? 'd-flex justify-content-between' : 'd-flex flex-column justify-content-center align-items-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>

                        <button mat-flat-button color="accent" (click)="regresarALaRutaAnterior()">
                            <mat-icon>arrow_left</mat-icon>
                            Volver al buscador</button>
                    </div>
                </div>

                <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
</div>
<div #tp class="container-custom-content animate__animated animate__fadeIn  buscador-pedidos">

    <mat-accordion multi>
        <mat-expansion-panel [expanded]="true" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Datos del pedido
                </mat-panel-title>

            </mat-expansion-panel-header>
            <form [formGroup]="tpForm">
                <div class="container-fluid mt-4">

                    <div class="row align-items-center">

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.FechaCreacion}}</mat-label>

                                <input readonly [value]="tpForm.controls['fechaCreacion'].value | date:'dd/MM/yyyy'"
                                    type="text" matInput>
                            </mat-form-field>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.TipoOrden}}</mat-label>

                                <input readonly formControlName="tipoOrden" type="text" matInput>
                            </mat-form-field>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroOrdenSAP}}</mat-label>

                                <input readonly formControlName="nroOrdenSAP" type="text" matInput>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroPedido}}</mat-label>

                                <input readonly formControlName="nroPedido" type="text" matInput>
                            </mat-form-field>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <!-- <div [ngClass]="clasePorEstado(tpForm.get('idEstado').value)">
                                {{tpForm.get('estado').value}}

                            </div> -->
                            <mat-card class="mat-card-estado estadoTP_{{tpForm.get('idEstado').value}}">
                                <mat-card-content>{{tpForm.get('estado').value}}</mat-card-content>
                            </mat-card>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                            <mat-divider>
                            </mat-divider>
                        </div>



                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && tpForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Division}}</mat-label>
                                <mat-select (selectionChange)='seleccionarDivision($event.value)'
                                    [hidden]="dataSourceItems.data.length" [compareWith]="compareDivisiones"
                                    formControlName="idDivision">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let d of divisiones" [value]="d.id">{{d.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <input *ngIf="divisionSeleccionada != null && dataSourceItems.data.length" readonly
                                    [value]="divisionSeleccionada.displayValue" type="text" matInput>
                                <mat-error
                                    *ngIf="(tpForm.get('idDivision').hasError('required')) && tpForm.get('idDivision').touched">
                                    {{Validaciones.IdDivision}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="divisionSeleccionada != null && (dataSourceItems.data.length || tpForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.Division}}</mat-label>
                                <input readonly [value]="divisionSeleccionada.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>


                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                            <mat-form-field
                                [hidden]="isInRole('DISTRIBUIDOR') && dataSourceItems.data.length  && tpForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" class="example-full-width" appearance="outline">
                                <mat-label>{{Etiquetas.Cliente}}</mat-label>
                                <input (change)="handleEmptyInputCliente($event)" matInput [matAutocomplete]="autoC"
                                    [formControl]="fcAutocompleteCliente" placeholder="Nro. cliente, nombre, etc...">
                                <button type="button" matSuffix mat-icon-button
                                    matTooltip="Limpiar cliente seleccionado" (click)="limpiarCliente(true)">

                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #autoC="matAutocomplete"
                                    (optionSelected)='seleccionarCliente($event.option.value,null,null,null,null,null)'
                                    [displayWith]="getOptionTextCliente">
                                    <mat-option *ngIf="loadingFcAutocompleteCliente"
                                        class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!loadingFcAutocompleteCliente">
                                        <mat-option *ngFor="let c of clientesEncontrados" [value]="c">
                                            {{c.displayValue}}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3" *ngIf="avisoCreditoVencido">


                            <mat-card class="mat-card-aviso-credito animate__animated animate__zoomIn animate__faster">
                                <H5>
                                    Aviso
                                </H5>

                                <mat-card-content>

                                    <p>{{Mensajes.CreditoVencido}}</p>

                                </mat-card-content>

                            </mat-card>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroCliente}}</mat-label>
                                <input readonly formControlName="nroCliente" type="text" matInput>
                                <mat-error
                                    *ngIf="(tpForm.get('nroCliente').hasError('required')) && tpForm.get('nroCliente').touched">
                                    {{Validaciones.Cliente}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NombreCliente}}</mat-label>
                                <input readonly formControlName="nombreCliente" type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CuitCliente}}</mat-label>
                                <input readonly formControlName="cuit" type="text" matInput>
                            </mat-form-field>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline"
                                *ngIf="!dataSourceItems.data.length && tpForm.controls['idEstado'].value == 1 && alta">
                                <mat-label>{{Etiquetas.IdGrupoCliente}}</mat-label>
                                <mat-select [hidden]="dataSourceItems.data.length"
                                    (selectionChange)='seleccionarGC($event.value)' [compareWith]="compareGC"
                                    formControlName="idGrupoCliente">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let gc of gcs" [value]="gc.id">{{gc.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <input *ngIf="gcSeleccionado != null && dataSourceItems.data.length" readonly
                                    [value]="gcSeleccionado.displayValue" type="text" matInput>
                                <mat-error
                                    *ngIf="(tpForm.get('idGrupoCliente').hasError('required')) && tpForm.get('idGrupoCliente').touched">
                                    {{Validaciones.IdGrupoCliente}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="gcSeleccionado != null && (dataSourceItems.data.length || tpForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.IdGrupoCliente}}</mat-label>
                                <input readonly [value]="gcSeleccionado.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                            <mat-divider>
                            </mat-divider>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                            <mat-form-field
                                *ngIf="!isInRole('VENDEDOR') && !dataSourceItems.data.length && tpForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.ZonaVendedor}}</mat-label>
                                <input (change)="handleEmptyInputVendedor($event)" matInput [matAutocomplete]="autoZV"
                                    [formControl]="fcAutocompleteZv" placeholder="Id, nombre, etc...">
                                <button type="button" matSuffix mat-icon-button
                                    matTooltip="Limpiar vendedor seleccionado" (click)="limpiarVendedor(true)">

                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #autoZV="matAutocomplete"
                                    (optionSelected)='seleccionarVendedor($event.option.value)'
                                    [displayWith]="getOptionTextZV">
                                    <mat-option *ngIf="loadingFcAutocompleteZV"
                                        class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!loadingFcAutocompleteZV">
                                        <mat-option *ngFor="let zv of zvsEncontradas" [value]="zv">
                                            {{zv.displayValue}}
                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.ZonaVendedorSeleccionada}}</mat-label>
                                <input *ngIf="zvSeleccionada == null" readonly [value]="" type="text" matInput>
                                <input *ngIf="zvSeleccionada != null" readonly [value]="zvSeleccionada.displayValue"
                                    type="text" matInput>
                                <mat-error
                                    *ngIf="(tpForm.get('idZonaVendedor').hasError('required')) && tpForm.get('idZonaVendedor').touched">
                                    {{Validaciones.ZonaVendedor}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!isInRole('VENDEDOR') && !dataSourceItems.data.length && tpForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">

                                <mat-label>{{Etiquetas.Region}}</mat-label>
                                <mat-select (selectionChange)='seleccionarRegion($event.value)'
                                    [compareWith]="compareRegiones" formControlName="idRegion">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let r of regiones" [value]="r.id">{{r.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(tpForm.get('idRegion').hasError('required')) && tpForm.get('idRegion').touched">
                                    {{Validaciones.IdRegion}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="regionSeleccionada != null && (isInRole('VENDEDOR') || dataSourceItems.data.length || tpForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.Region}}</mat-label>
                                <input readonly [value]="regionSeleccionada.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && tpForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CuentaDistribuidor}}</mat-label>
                                <mat-select [hidden]="dataSourceItems.data.length"
                                    [compareWith]="compareCuentasDistribuidores"
                                    formControlName="nroClienteDistribuidor"
                                    (selectionChange)='seleccionarCuentaDistribuidor($event.value)'>
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let d of cuentasDistribuidores"
                                        [value]="d.nroClienteDistribuidor">{{d.nombre}}
                                    </mat-option>
                                </mat-select>
                                <input *ngIf="ctaDistrubuidorSeleccionada != null && dataSourceItems.data.length"
                                    readonly [value]="ctaDistrubuidorSeleccionada.nombre" type="text" matInput>
                                <mat-error
                                    *ngIf="(tpForm.get('nroClienteDistribuidor').hasError('required')) && tpForm.get('nroClienteDistribuidor').touched">
                                    {{Validaciones.NroClienteDistribuidor}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="ctaDistrubuidorSeleccionada != null && (dataSourceItems.data.length || tpForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.CuentaDistribuidor}}</mat-label>
                                <input readonly [value]="ctaDistrubuidorSeleccionada.nombre" type="text" matInput>

                            </mat-form-field>

                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && tpForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Sucursal}}</mat-label>
                                <mat-select [compareWith]="compareDirecciones" formControlName="idSucursal"
                                    (selectionChange)='seleccionarDireccion($event.value)'>
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let d of direcciones" [value]="d.nroCliente">{{d.displayValue}}
                                    </mat-option>
                                </mat-select>

                                <mat-error
                                    *ngIf="(tpForm.get('idSucursal').hasError('required')) && tpForm.get('idSucursal').touched">
                                    {{Validaciones.IdSucursal}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf="direccionSeleccionada != null && (dataSourceItems.data.length || tpForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.Sucursal}}</mat-label>
                                <input readonly [value]="direccionSeleccionada.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroClienteDireccionRetiro}}</mat-label>
                                <input readonly formControlName="nroClienteDireccionRetiro" type="text" matInput>
                                <mat-error
                                    *ngIf="(tpForm.get('nroClienteDireccionRetiro').hasError('required')) && tpForm.get('nroClienteDireccionRetiro').touched">
                                    {{Validaciones.DireccionRetiro}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NombreClienteDireccionRetiro}}</mat-label>

                                <input readonly formControlName="nombreClienteDireccionRetiro" type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CalleNroDireccionRetiro}}</mat-label>

                                <input readonly formControlName="calleNroDireccionRetiro" type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CPDireccionRetiro}}</mat-label>

                                <input readonly formControlName="cpDireccionRetiro" type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.CiudadDireccionRetiro}}</mat-label>

                                <input readonly formControlName="ciudadDireccionRetiro" type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"></div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && tpForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.AlmacenEnvio}}</mat-label>
                                <mat-select
                                    (selectionChange)='seleccionarStorageLocation($event, $event.source.triggerValue)'
                                    [compareWith]="compareStoragesLocations"
                                    formControlName="idUbicacionAlmacenamiento">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let sl of storagesLocations" [value]="sl.id">{{sl.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(tpForm.get('idUbicacionAlmacenamiento').hasError('required')) && tpForm.get('idUbicacionAlmacenamiento').touched">
                                    {{Validaciones.StorageLocation}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline"
                                *ngIf=" slSeleccionado != null && (dataSourceItems.data.length || tpForm.controls['idEstado'].value != 1)">
                                <mat-label>{{Etiquetas.AlmacenEnvio}}</mat-label>
                                <input readonly [value]="slSeleccionado.displayValue" type="text" matInput>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                            <mat-divider>
                            </mat-divider>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.MotivoRetencion}}</mat-label>

                                <input readonly formControlName="motivoRetencion" type="text" matInput>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="!dataSourceItems.data.length && tpForm.controls['idEstado'].value == 1 && alta"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Comentario}}</mat-label>

                                <textarea #comentario matInput maxlength="1024" formControlName="comentario"
                                    type="text"></textarea>
                                <mat-hint align="start">Máximo: 1024
                                    caracteres</mat-hint>
                                <mat-hint align="end">{{comentario.value?.length
                                    || 0}} / 1024</mat-hint>

                            </mat-form-field>
                            <mat-form-field class="readonly-form-field"
                                *ngIf="dataSourceItems.data.length || tpForm.controls['idEstado'].value != 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Comentario}}</mat-label>

                                <textarea #comentario matInput readonly maxlength="1024" formControlName="comentario"
                                    type="text"></textarea>


                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field [ngClass]="dataSourceItems.data.length ? 'readonly-form-field' : ''"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.IdMoneda}}</mat-label>
                                <mat-select [hidden]="dataSourceItems.data.length "
                                    (selectionChange)='seleccionarMoneda($event.value)' [compareWith]="compareMonedas"
                                    formControlName="idMoneda">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let m of monedas" [value]="m.id">{{m.id}}
                                    </mat-option>
                                </mat-select>
                                <input *ngIf="monedaSeleccionada != null && dataSourceItems.data.length " readonly
                                    [value]="monedaSeleccionada.id" type="text" matInput>
                                <mat-error
                                    *ngIf="(tpForm.get('idMoneda').hasError('required')) && tpForm.get('idMoneda').touched">
                                    {{Validaciones.IdMoneda}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field *ngIf="tpForm.controls['idEstado'].value == 1 && alta" color="accent-darker"
                                appearance="outline">
                                <mat-label>{{Etiquetas.Glosa}}</mat-label>

                                <textarea #glosa matInput maxlength="300" formControlName="glosa"
                                    type="text"></textarea>
                                <mat-hint align="start">Máximo: 300 caracteres</mat-hint>
                                <mat-hint align="end">{{glosa.value?.length || 0}} / 300</mat-hint>
                            </mat-form-field>
                            <mat-form-field class="readonly-form-field" *ngIf="tpForm.controls['idEstado'].value != 1"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Glosa}}</mat-label>

                                <textarea #glosa matInput maxlength="300" readonly formControlName="glosa"
                                    type="text"></textarea>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroRemito}}</mat-label>

                                <input readonly formControlName="nroRemito" type="text" matInput>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">

                            <mat-divider>
                            </mat-divider>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.IdTipoListaPrecios}}</mat-label>
                                <input readonly formControlName="idTipoListaPrecios" type="text" matInput>


                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.TipoListaPrecios}}</mat-label>

                                <input readonly formControlName="tipoListaPrecios" type="text" matInput>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.IdTerminoPago}}</mat-label>
                                <input readonly formControlName="idTerminoPago" type="text" matInput>

                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.TerminoPago}}</mat-label>

                                <input readonly formControlName="terminoPago" type="text" matInput>

                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field
                                *ngIf="tpForm.controls['idEstado'].value == 10 && (isInRole('CONTING LOGISTICA') || isInRole('LOGISTICA'))"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroOC}}</mat-label>

                                <input matInput formControlName="nroOC" type="text">

                            </mat-form-field>

                            <mat-form-field class="readonly-form-field"
                                *ngIf="(tpForm.get('nroOC')?.value != null && tpForm.get('nroOC')?.value !== '') && tpForm.controls['idEstado'].value != 10"
                                color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.NroOC}}</mat-label>
                                <input readonly matInput formControlName="nroOC" type="text">

                            </mat-form-field>


                        </div>

                    </div>

                </div>
            </form>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Ítems del pedido
                </mat-panel-title>


            </mat-expansion-panel-header>
            <form [formGroup]="tpItemForm">
                <div class="container-fluid mt-4">

                    <div class="row align-items-center" *ngIf="tpForm.controls['idEstado'].value == 1 && alta">

                        <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Planta}}</mat-label>
                                <mat-select (selectionChange)='seleccionarPlantaItem($event.value)'
                                    [compareWith]="comparePlantas" formControlName="idPlanta">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let p of plantasItem" [value]="p.idPlanta">{{p.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(tpItemForm.get('idPlanta').hasError('required')) && tpItemForm.get('idPlanta').touched">
                                    {{Validaciones.IdPlanta}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.StorageLocation}}</mat-label>
                                <mat-select (selectionChange)='seleccionarStorageLocation($event.value)'
                                    [compareWith]="compareStoragesLocations"
                                    formControlName="idUbicacionAlmacenamiento">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let sl of storagesLocations" [value]="sl.id">{{sl.id}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(tpItemForm.get('idUbicacionAlmacenamiento').hasError('required')) && tpItemForm.get('idUbicacionAlmacenamiento').touched">
                                    {{Validaciones.StorageLocation}}
                                </mat-error>
                            </mat-form-field>
                        </div> -->

                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Item}}</mat-label>
                                <input (change)="handleEmptyInputItem($event)" matInput [matAutocomplete]="autoItem"
                                    [formControl]="fcAutocompleteItem" placeholder="Código, descripción, etc...">
                                <button type="button" matSuffix mat-icon-button (click)="limpiarItem(true)"
                                    matTooltip="Limpiar ítem seleccionado">
                                    <mat-icon color="accent-darker">close</mat-icon>
                                </button>

                                <mat-autocomplete #autoItem="matAutocomplete"
                                    (optionSelected)='seleccionarItem($event.option.value)'
                                    [displayWith]="getOptionTextItem">
                                    <mat-option *ngIf="loadingFcAutocompleteItem"
                                        class="is-loading">Cargando...</mat-option>
                                    <ng-container *ngIf="!loadingFcAutocompleteItem">
                                        <mat-option *ngFor="let i of itemsEncontrados" [value]="i">
                                            {{i.displayValue}}

                                        </mat-option>
                                    </ng-container>
                                </mat-autocomplete>

                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.IdProducto}}</mat-label>
                                <input *ngIf="itemSeleccionado == null" readonly [value]="" type="text" matInput>
                                <input *ngIf="itemSeleccionado != null" readonly [value]="itemSeleccionado.idProducto"
                                    type="text" matInput>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Producto}}</mat-label>
                                <input *ngIf="itemSeleccionado == null" readonly [value]="" type="text" matInput>
                                <input *ngIf="itemSeleccionado != null" readonly [value]="itemSeleccionado.producto"
                                    type="text" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.Cantidad}}</mat-label>
                                <input appThreeDigitDecimaNumber formControlName="cantidad" type="text" matInput>
                                <mat-error
                                    *ngIf=" !tpItemForm.controls['cantidad'].valid && tpItemForm.get('cantidad').touched">
                                    {{Validaciones.Cantidad}}
                                </mat-error>
                            </mat-form-field>
                        </div>


                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>{{Etiquetas.IdLote}}</mat-label>
                                <mat-select (selectionChange)='seleccionarLote($event.value)'
                                    [compareWith]="compareLotes" formControlName="idLote">
                                    <mat-option [value]="">- Seleccione -</mat-option>
                                    <mat-option *ngFor="let l of lotes" [value]="l.value">{{l.value}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="(tpItemForm.get('idLote').hasError('required')) && tpItemForm.get('idLote').touched">
                                    {{Validaciones.IdLote}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3" *ngIf="avisoUnidadesPallet">

                            <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                                <mat-card-content>

                                    <p>{{this.mensajeUnidadesPallet}} </p>

                                </mat-card-content>

                            </mat-card>
                        </div>
                        <div class="mat-toolbar-custom">
                            <mat-toolbar>
                                <mat-toolbar-row>

                                    <button mat-flat-button color="accent" (click)="nuevoItem()">
                                        <mat-icon>add</mat-icon>
                                        Nuevo ítem / Cargar ítem</button>

                                </mat-toolbar-row>

                            </mat-toolbar>

                        </div>

                    </div>

                    <div class="mat-table-pedidos">
                        <table [hidden]="codigoEdit == 0" mat-table matTableResponsive [dataSource]="dataSourceItems"
                            matSort #matSortItems="matSort" matSortActive="nroLinea" matSortDirection="asc">

                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Acciones}} </th>
                                <td mat-cell *matCellDef="let tpi">
                                    <div>

                                        <button
                                            *ngIf="(tpForm.controls['idEstado'].value == 1 && alta) || (tpForm.controls['idEstado'].value == 10 && (isInRole('CONTING LOGISTICA') || isInRole('LOGISTICA')))"
                                            matTooltip="{{Tooltips.Editar}}" (click)="dialogItem(tpi)" mat-icon-button
                                            color="primary-darker">
                                            <mat-icon color="accent-darker">edit</mat-icon>
                                        </button>

                                        <button 
                                            *ngIf="(tpForm.controls['idEstado'].value == 1 && alta) || (tpForm.controls['idEstado'].value == 10 && (isInRole('CONTING LOGISTICA') || isInRole('LOGISTICA')))"
                                            (click)="eliminarItem(tpi)" matTooltip="{{Tooltips.Eliminar}}"
                                            mat-icon-button color="primary-darker">
                                            <mat-icon color="accent-darker">delete</mat-icon>
                                        </button>

                                    </div>

                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="nroLinea">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.NroLinea}}
                                </th>
                                <td mat-cell *matCellDef="let tpi">
                                    {{tpi.nroLinea}} </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>
                            <ng-container matColumnDef="idProducto">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.IdProducto}}
                                </th>
                                <td mat-cell *matCellDef="let tpi">
                                    {{tpi.idProducto}} </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="producto">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.Producto}}
                                </th>
                                <td mat-cell *matCellDef="let tpi">
                                    {{tpi.producto}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="cantidad">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.Cantidad}}
                                </th>
                                <td mat-cell *matCellDef="let tpi">
                                    {{tpi.cantidad | number}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>

                            <ng-container matColumnDef="idLote">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    {{Etiquetas.IdLote}}
                                </th>
                                <td mat-cell *matCellDef="let tpi">
                                    {{tpi.idLote}}
                                </td>
                                <td mat-footer-cell *matFooterCellDef> </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsItems"></tr>
                            <tr mat-row *matRowDef="let tpi; columns: displayedColumnsItems;">
                            </tr>
                            <tr mat-footer-row *matFooterRowDef="displayedColumnsItems"></tr>
                            <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                                <td class="mat-cell" [attr.colspan]="displayedColumnsItems.length">
                                    {{Etiquetas.SinRegistros}}
                                </td>
                            </tr>
                        </table>

                        <mat-paginator #matPaginatorItems="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                            showFirstLastButtons>
                        </mat-paginator>
                    </div>
                </div>
            </form>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="dataSourceItems.data.length &&  dataSourceRemitos.data.length " [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Guías de Despacho
                </mat-panel-title>
            </mat-expansion-panel-header>
            <!-- <mat-tab label="Guías de Despacho"> -->
            <div class="container-fluid">
                <div class="row align-items-center justify-content-evenly">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <mat-form-field color="accent-darker" appearance="standard">
                            <mat-label>{{Etiquetas.Buscar}}</mat-label>
                            <input matInput (keyup)="applyFilterRemitos($event)" #input>
                        </mat-form-field>

                        <div class="mat-table-pedidos">
                            <table mat-table matTableResponsive [dataSource]="dataSourceRemitos" matSort
                                #matSortRemitos="matSort" matSortActive="nroRemito" matSortDirection="asc">


                                <ng-container matColumnDef="acciones">
                                    <th mat-header-cell *matHeaderCellDef>
                                        {{Etiquetas.Acciones}}
                                    </th>
                                    <td mat-cell *matCellDef="let r">

                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="nroRemito">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.NroRemito}}
                                    </th>
                                    <td mat-cell *matCellDef="let r">
                                        {{r.nroRemito}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="idProducto">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.IdProducto}}
                                    </th>
                                    <td mat-cell *matCellDef="let r">
                                        {{r.idProducto}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="idLote">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.IdLote}}
                                    </th>
                                    <td mat-cell *matCellDef="let r">
                                        {{r.idLote}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="cantidad">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Cantidad}}
                                    </th>
                                    <td mat-cell *matCellDef="let r">
                                        {{r.cantidad | number}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="fecha">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.Fecha}}
                                    </th>
                                    <td mat-cell *matCellDef="let r">
                                        {{r.fecha}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="nombrePDF">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                        {{Etiquetas.NombrePDF}}
                                    </th>
                                    <td mat-cell *matCellDef="let r">
                                        <a class="linkPDFs" (click)="download(r.nombrePDF)">
                                            {{r.nombrePDF}}
                                        </a>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsRemitos">
                                </tr>
                                <tr mat-row *matRowDef="let r; columns: displayedColumnsRemitos;">
                                </tr>


                                <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                                    <td class="mat-cell" [attr.colspan]="displayedColumnsRemitos.length">
                                        {{Etiquetas.SinRegistros}}
                                    </td>
                                </tr>
                            </table>

                            <mat-paginator #matPaginatorRemitos="matPaginator" [pageSizeOptions]="[10, 20, 50]"
                                showFirstLastButtons>
                            </mat-paginator>
                        </div>
                    </div>
                </div>
            </div>
            <!-- </mat-tab> -->
        </mat-expansion-panel>
    </mat-accordion>


    <div class="mat-toolbar-custom">
        <mat-toolbar>
            <mat-toolbar-row>

                <button mat-flat-button color="accent" (click)="guardar()"
                    *ngIf="tpForm.controls['idEstado'].value == 1 && alta">
                    <mat-icon>add</mat-icon>
                    Guardar</button>

                <button *ngIf="codigoEdit != 0" mat-flat-button color="accent" (click)="dialogLogAutorizaciones()">
                    <mat-icon>search</mat-icon>
                    Workflow</button>



                <button *ngIf="tpForm.controls['rechazar'].value == true && tpForm.controls['idEstado'].value != 1"
                    mat-flat-button color="warn" (click)="dialogComentario(2,true)">
                    <mat-icon>thumb_down</mat-icon>
                    Rechazar
                </button>

                <button
                    *ngIf="tpForm.valid && dataSourceItems.data.length && tpForm.controls['idEstado'].value == 7 && tpForm.controls['enviadoDistribuidor'].value == false && (isInRole('ADM') ||isInRole('CONTING LOGISTICA') || isInRole('LOGISTICA'))"
                    mat-flat-button color="primary" (click)="envioMailDistribuidor()">
                    <mat-icon>mail</mat-icon>Enviar a Distribuidor
                </button>
                <button *ngIf="tpForm.valid && dataSourceItems.data.length && tpForm.controls['aprobar'].value == true"
                    mat-flat-button color="primary" (click)="dialogComentario(1,false)">
                    <mat-icon>thumb_up</mat-icon>
                    Aprobar</button>


                <span class="mat-toolbar-row-separador"></span>
                <button mat-flat-button color="accent" (click)="regresarALaRutaAnterior()">
                    <mat-icon>arrow_left</mat-icon>
                    Volver al buscador</button>

            </mat-toolbar-row>
        </mat-toolbar>

    </div>

</div>